var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80078 1.30078C6.42542 1.30078 4.50078 3.22463 4.50078 5.59765C4.50078 7.97067 6.42542 9.89452 8.80078 9.89452C11.1761 9.89452 13.1008 7.97067 13.1008 5.59765C13.1008 3.22463 11.1761 1.30078 8.80078 1.30078ZM3.50078 5.59765C3.50078 2.67173 5.87375 0.300781 8.80078 0.300781C11.7278 0.300781 14.1008 2.67173 14.1008 5.59765C14.1008 8.52357 11.7278 10.8945 8.80078 10.8945C5.87375 10.8945 3.50078 8.52357 3.50078 5.59765ZM19.5008 11.5008V8.00078H20.5008V11.5008H24.0008V12.5008H20.5008V16.0008H19.5008V12.5008H16.0008V11.5008H19.5008ZM12.0008 15.6914L5.60078 15.6914C3.22584 15.6914 1.30078 17.6159 1.30078 19.9906V22.6862L16.3008 22.6862V19.9906C16.3008 17.6159 14.3757 15.6914 12.0008 15.6914ZM5.60078 14.6914L12.0008 14.6914C14.9278 14.6914 17.3008 17.0634 17.3008 19.9906V23.6862L0.300781 23.6862V19.9906C0.300781 17.0634 2.67378 14.6914 5.60078 14.6914Z",
    fill: "#8586A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviting);
export default __webpack_public_path__ + "static/media/inviting.c470fd0021775ed25860d2d58bd39556.svg";
export { ForwardRef as ReactComponent };